import { MaskedLines, Chapter, Reveal } from "@/components/motion";

export default function PageHero({ index, label, titleLines, intro, image }) {
  return (
    <section className="relative overflow-hidden bg-navy" data-testid={`page-hero-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
      {image && (
        <>
          <div className="absolute inset-0">
            <img src={image} alt="" className="h-full w-full object-cover opacity-40" />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/50" />
        </>
      )}
      <div className="absolute inset-0 bg-blueprint-dark opacity-30" />
      <div className="relative z-10 mx-auto max-w-7xl px-6 pb-20 pt-40 lg:pb-28">
        <Chapter index={index} label={label} dark />
        <MaskedLines
          lines={titleLines}
          delay={0.15}
          className="mt-8 font-heading text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl"
        />
        {intro && (
          <Reveal delay={0.5} className="mt-8 max-w-2xl">
            <p className="text-base leading-relaxed text-white/70 md:text-lg">{intro}</p>
          </Reveal>
        )}
      </div>
      <div className="relative z-10 h-1.5 w-full bg-gold" />
    </section>
  );
}
